<template>
  <div :class="[
    showBorderLoader ? 'loader-border': 'bg-white',
    'rounded-xl outline outline-1 overflow-hidden relative outline-box-against-white-background',
    shadows[shadow],
    paddings[padding],
  ]">
    <div
      v-if="showBarsLoader"
      class="flex items-center justify-center h-full w-full"
    >
      <div class="z-20 loader-bars loader-bars--size-md"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "adivare-box-loader",
  props: {
    // show border loader
    showBorderLoader: {
      type: Boolean,
      default: false,
      required: false,
    },
    // show bars loader
    showBarsLoader: {
      type: Boolean,
      default: false,
      required: false,
    },
    shadow: {
      type: String,
      default: 'none',
      required: false,
    },
    padding: {
      type: String,
      default: 'none',
      required: false,
    },
  },
  data() {
    return {
      paddings: {
        'none': '',
        'sm': 'py-6 px-4 md:p-6',
        'md': 'py-8 px-6 md:p-8',
        'lg': 'py-10 px-8 md:p-10',
      },
      shadows: {
        'none': '',
        'againstWhiteBackground': 'shadow-lg shadow-light-grey-200/50 outline-box-against-white-background',
        'againstBlueBackground': 'shadow-lg shadow-light-blue-500/50 outline-box-against-blue-background',
      }
    }
  },
}
</script>
